// ---------------------------------------------------------------------------
// DemoBanner — shown while the console is serving synthesised sample data.
// ---------------------------------------------------------------------------
import React from "react";

function DemoBanner({visible, i18n}) {
    if (!visible) return null;
    return (
        <div className="banner">
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                <circle cx="8" cy="8" r="6.5" stroke="currentColor" strokeWidth="1.5" />
                <path d="M8 4.7v4M8 11h.01" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" />
            </svg>
            <span>
                {i18n.t("demo")}
                <code>CONFIG.DEMO = false</code>
                {i18n.t("demo2")}
            </span>
        </div>
    );
}

export default DemoBanner;
